import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { FaLock, FaUser } from 'react-icons/fa';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      if (response.data.success) {
        localStorage.setItem('adminPassword', password);
        toast.success('Login successful!');
        navigate('/admin/dashboard');
      }
    } catch (error) {
      toast.error('Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0F5132] to-[#1a6b47]' data-testid='admin-login-page'>
      <div className='bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md'>
        <div className='text-center mb-8'>
          <div className='w-20 h-20 bg-[#0F5132] rounded-full flex items-center justify-center mx-auto mb-4'>
            <FaLock className='text-white text-3xl' />
          </div>
          <h1 className='text-3xl font-bold text-[#0F5132] mb-2'>Admin Panel</h1>
          <p className='text-gray-600'>Shivangel Ayurveda & Nutraceuticals</p>
        </div>

        <form onSubmit={handleLogin} className='space-y-6'>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>
              <FaUser className='inline mr-2' />
              Admin Password
            </label>
            <Input
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder='Enter admin password'
              required
              data-testid='admin-password-input'
              className='w-full'
            />
          </div>

          <Button
            type='submit'
            disabled={loading}
            data-testid='admin-login-button'
            className='w-full bg-[#0F5132] hover:bg-[#0D4228] text-white py-6 text-lg font-bold'
          >
            {loading ? 'Logging in...' : 'Login to Admin Panel'}
          </Button>
        </form>

        <div className='mt-6 text-center text-sm text-gray-500'>
          <p>Default password: admin123</p>
          <p className='mt-2'>Contact IT team to change password</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;